
import {map, filter, mergeMap} from 'rxjs/operators';
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {LogManager, LogCat} from "../../log";
import {TranslateLanguage} from "../interfaces/translate.language";
import {UserContextService} from "../../../app.services/user.context/services/user.context.service";
import {UserContext} from "../../../app.services/user.context/services/user.context";
import {TranslateConfigService} from "./translate.config.service";


/**
	* ***************************************************************
	* Service that wraps and extends the service of ng2-translate.
	*
	* This service used to configuration only, to translate use
	* in the service TranslateService.
	*
	* Written by: Dana Moshe
	* ***************************************************************
	*/
@Injectable({ providedIn: 'root' })
  export class UserContextTranslateService {
	constructor(private usrCtx:UserContextService,
				private translateConfigService: TranslateConfigService) { }

	/**
	 * Set the language by user preferences.
	 *
	 * @returns Observable<any> that emit event after the set.
	 */
	public setByUserLanguage():Observable<any> {
		LogManager.debug(LogCat.Translate.Load,"setByUserLanguage");
		if (this.translateConfigService.forceSpecificLanguage) {
			return this.translateConfigService.use(this.translateConfigService.forceSpecificLanguage);
		} else {
			return this.getUserLanguage().pipe(mergeMap((lang: TranslateLanguage) => {
				LogManager.debug(LogCat.Translate.Load, "setByUserLanguage - after getUserLanguage");
				return this.translateConfigService.use(lang);
			}));
		}
	}

	/**
	* Get the user language preferences.
	*
	* @returns HttpObservable<string> with the user language preferences.
	*/
	private getUserLanguage():Observable<TranslateLanguage> {
		return this.translateConfigService.getLanguages(true).pipe(mergeMap(()=> {
			LogManager.debug(LogCat.Translate.Load,"getUserLanguage - load of languages available");
			return this.usrCtx.getUserContextObservable().pipe(filter(x=>x),map((ctx:UserContext)=> {
				LogManager.debug(LogCat.Translate.Load,"getUserLanguage - user context set");
				return this.translateConfigService.languages.find(curr => curr.languageKey === ctx.defaultLangKey);
			}),);
		}));
	}
}
